import React from 'react'
import SidebarNavItem from './SidebarNavItem'

const DesktopSidebar = ({
  user,
  activeTab,
  onTabClick,
  onLogout,
  isLoggingOut,
}) => {
  return (
    <div className="hidden lg:block w-72 border-r border-slate-200 px-1 pr-4 ">
      <div className="pb-5 pt-5 text-slate-700 mt-[111px] flex justify-between items-center border-b border-b-slate-200">
        <div className="text-xl font-bold flex items-center gap-3 truncate">
          <i className="fas fa-user-circle flex-shrink-0 "></i>
          <span className="truncate">{user?.name}</span>
        </div>
        <button
          className="p-3 bg-slate-50 text-slate-600 border border-slate-200 rounded-full cursor-pointer transition-all duration-200 flex hover:bg-red-50 hover:text-citrus-red hover:border-red-200 disabled:opacity-50 disabled:cursor-not-allowed justify-center items-center flex-shrink-0 w-10 h-10"
          onClick={onLogout}
          disabled={isLoggingOut}
        >
          {isLoggingOut ? (
            <i className="fas fa-spinner fa-spin"></i>
          ) : (
            <i className="fas fa-sign-out-alt"></i>
          )}
        </button>
      </div>

      <div className="my-8 flex flex-col gap-3">
        <SidebarNavItem
          icon="fas fa-shopping-bag"
          label="შეკვეთები"
          tabName="orders"
          activeTab={activeTab}
          onTabClick={onTabClick}
        />
        <SidebarNavItem
          icon="fas fa-user"
          label="პროფილი"
          tabName="profile"
          activeTab={activeTab}
          onTabClick={onTabClick}
        />
      </div>
    </div>
  )
}

export default DesktopSidebar
